import { render, staticRenderFns } from "./NeoparentPosts.vue?vue&type=template&id=61fa16b1&scoped=true"
import script from "./NeoparentPosts.vue?vue&type=script&lang=js"
export * from "./NeoparentPosts.vue?vue&type=script&lang=js"
import style0 from "./NeoparentPosts.vue?vue&type=style&index=0&id=61fa16b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa16b1",
  null
  
)

export default component.exports